(() => {
  const root = document.querySelector('[data-eone-collection-search]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const input = root.querySelector('input[type="search"]');
  const button = root.querySelector('button');
  const status = root.querySelector('[aria-live]');
  const pageSize = Number(root.dataset.pageSize);
  const indexCache = new Map();
  let grid, originalHTML = '', generation = 0, searching = false;
  const savedCounts = new Map();
  function collect(doc) {
    return Array.from(doc.querySelectorAll('#product-grid > .grid__item')).map(card => {
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      return { handle: href.split('/products/')[1]?.split(/[?#]/)[0], html: card.outerHTML };
    }).filter(card => card.handle);
  }
  function indicators(count) {
    for (const id of ['ProductCount', 'ProductCountDesktop']) {
      const el = document.getElementById(id);
      if (!el) continue;
      if (count === null) {
        if (savedCounts.has(id)) el.textContent = savedCounts.get(id);
      } else {
        if (!savedCounts.has(id)) savedCounts.set(id, el.textContent);
        el.textContent = `${count} matching design${count === 1 ? '' : 's'}`;
      }
    }
    grid?.closest('.shopify-section')?.querySelectorAll('.pagination-wrapper').forEach(el => {
      el.hidden = count !== null;
    });
    if (count === null) savedCounts.clear();
  }
  function reset() {
    generation++;
    if (grid && grid === document.getElementById('product-grid') && searching) grid.innerHTML = originalHTML;
    indicators(null);
    searching = false;
    status.textContent = '';
    root.removeAttribute('aria-busy');
  }
  async function getDocument(url) {
    const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error('Collection unavailable');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }
  async function getIndex(base) {
    const key = base.href;
    if (!indexCache.has(key)) {
      indexCache.set(key, (async () => {
        const products = [];
        let page = 1;
        while (page) {
          const url = new URL(base);
          url.searchParams.set('view', 'eone-design-index');
          url.searchParams.set('page', String(page));
          const doc = await getDocument(url);
          const data = JSON.parse(doc.querySelector('[data-eone-design-index]')?.textContent || 'null');
          if (!data || !Array.isArray(data.products)) throw new Error('Search index unavailable');
          products.push(...data.products);
          if (data.next && data.next <= page) throw new Error('Invalid search pagination');
          page = data.next;
        }
        return products;
      })().catch(error => { indexCache.delete(key); throw error; }));
    }
    return indexCache.get(key);
  }
  async function search() {
    const query = input.value.trim().toLowerCase();
    if (!query) { reset(); return; }
    const liveGrid = document.getElementById('product-grid');
    if (!liveGrid) return;
    if (grid !== liveGrid || !searching) {
      grid = liveGrid;
      originalHTML = grid.innerHTML;
      savedCounts.clear();
    }
    const run = ++generation;
    status.textContent = 'Searching this collection...';
    root.setAttribute('aria-busy', 'true');
    try {
      const base = new URL(location.href);
      base.hash = '';
      base.searchParams.delete('page');
      base.searchParams.delete('view');
      base.searchParams.delete('section_id');
      const products = await getIndex(base);
      if (run !== generation) return;
      const matches = products.map((product, index) => ({ ...product, page: Math.floor(index / pageSize) + 1 }))
        .filter(product => `${product.title} ${product.handle} ${product.alt || ''}`.toLowerCase().includes(query));
      const cards = new Map(collect(document).map(card => [card.handle, card.html]));
      const pages = [...new Set(matches.filter(product => !cards.has(product.handle)).map(product => product.page))];
      const sectionId = grid.closest('.shopify-section').id.replace('shopify-section-', '');
      for (const page of pages) {
        if (run !== generation) return;
        const url = new URL(base);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', sectionId);
        collect(await getDocument(url)).forEach(card => cards.set(card.handle, card.html));
      }
      if (run !== generation || grid !== document.getElementById('product-grid')) return;
      if (matches.some(product => !cards.has(product.handle))) throw new Error('Some results could not load');
      grid.innerHTML = matches.length ? matches.map(product => cards.get(product.handle)).join('') : '<li class="eone-design-search__empty">No matching designs found. Try another keyword or request a custom design below.</li>';
      searching = true;
      indicators(matches.length);
      status.textContent = `${matches.length} matching design${matches.length === 1 ? '' : 's'} in this collection.`;
    } catch (error) {
      if (run === generation) status.textContent = 'Search could not finish. Please try again. You can still browse the products below.';
    } finally {
      if (run === generation) root.removeAttribute('aria-busy');
    }
  }
  button.addEventListener('click', search);
  input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); search(); } });
  input.addEventListener('input', () => { if (!input.value.trim()) reset(); else { generation++; root.removeAttribute('aria-busy'); } });
  document.addEventListener('change', event => {
    if (event.target.closest('facet-filters-form')) { reset(); input.value = ''; }
  });
})();
